import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

const SENSITIVE_PHONE_POSITIONS = [
  "Генеральный директор",
  "Главный бухгалтер",
]

export function isPhoneHidden(position?: string): boolean {
  return !!position && SENSITIVE_PHONE_POSITIONS.includes(position)
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Преобразует относительный URL изображения в полный URL бэкенда
 * @param photoUrl - относительный URL изображения (например, /uploads/users/photos/ldap_eshikhov.jpg)
 * @returns полный URL изображения или пустую строку
 */
export function getImageUrl(photoUrl: string | undefined): string {
  if (!photoUrl) return ""
  
  // Если URL уже полный (начинается с http:// или https://), возвращаем как есть
  if (photoUrl.startsWith("http://") || photoUrl.startsWith("https://")) {
    return photoUrl
  }
  
  // Получаем базовый URL API из переменной окружения
  const apiUrl = process.env.NEXT_PUBLIC_API_URL || "http://localhost:8081"
  
  // Убираем /api из конца базового URL, если он там есть
  const baseUrl = apiUrl.replace(/\/api\/?$/, "")
  
  // Убираем начальный слэш из photoUrl, если он есть
  const cleanPhotoUrl = photoUrl.startsWith("/") ? photoUrl : `/${photoUrl}`
  
  return `${baseUrl}${cleanPhotoUrl}`
}

/**
 * Форматирует ISO-время в HH:mm с учётом офсета стенда.
 * Для biometria-записей «местное» время = момент + clockOffsetMinutes (UTC-компоненты),
 * а не таймзона браузера смотрящего. Для ERP-записей (offset = 0/undefined)
 * сохраняется прежнее поведение — форматирование в локальной таймзоне браузера.
 */
export function formatKioskLocal(
  iso: string | null | undefined,
  offsetMinutes: number | undefined
): string | null {
  if (!iso) return null
  const d = new Date(iso)
  if (isNaN(d.getTime())) return null
  if (!offsetMinutes) {
    return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`
  }
  const shifted = new Date(d.getTime() + offsetMinutes * 60_000)
  return `${String(shifted.getUTCHours()).padStart(2, "0")}:${String(shifted.getUTCMinutes()).padStart(2, "0")}`
}
